import stayingAheadOfTheCurveXsPng from './assets/StayingAheadOfTheCurve-xs.png'
import stayingAheadOfTheCurveXsWebp from './assets/StayingAheadOfTheCurve-xs.webp'
import stayingAheadOfTheCurveXsPng2x from './assets/StayingAheadOfTheCurve-xs@2x.png'
import stayingAheadOfTheCurveXsWebp2x from './assets/StayingAheadOfTheCurve-xs@2x.webp'
import stayingAheadOfTheCurveSmPng from './assets/StayingAheadOfTheCurve-sm.png'
import stayingAheadOfTheCurveSmWebp from './assets/StayingAheadOfTheCurve-sm.webp'
import stayingAheadOfTheCurveSmPng2x from './assets/StayingAheadOfTheCurve-sm@2x.png'
import stayingAheadOfTheCurveSmWebp2x from './assets/StayingAheadOfTheCurve-sm@2x.webp'

import wantToRetainCustomersXsPng from './assets/WantToRetainCustomers-xs.png'
import wantToRetainCustomersXsWebp from './assets/WantToRetainCustomers-xs.webp'
import wantToRetainCustomersXsPng2x from './assets/WantToRetainCustomers-xs@2x.png'
import wantToRetainCustomersXsWebp2x from './assets/WantToRetainCustomers-xs@2x.webp'
import wantToRetainCustomersSmPng from './assets/WantToRetainCustomers-sm.png'
import wantToRetainCustomersSmWebp from './assets/WantToRetainCustomers-sm.webp'
import wantToRetainCustomersSmPng2x from './assets/WantToRetainCustomers-sm@2x.png'
import wantToRetainCustomersSmWebp2x from './assets/WantToRetainCustomers-sm@2x.webp'

import thePayoffXsPng from './assets/ThePayoff-xs.png'
import thePayoffXsWebp from './assets/ThePayoff-xs.webp'
import thePayoffXsPng2x from './assets/ThePayoff-xs@2x.png'
import thePayoffXsWebp2x from './assets/ThePayoff-xs@2x.webp'
import thePayoffSmPng from './assets/ThePayoff-sm.png'
import thePayoffSmWebp from './assets/ThePayoff-sm.webp'
import thePayoffSmPng2x from './assets/ThePayoff-sm@2x.png'
import thePayoffSmWebp2x from './assets/ThePayoff-sm@2x.webp'

import aiAndMlXsPng from './assets/AIAndML-xs.png'
import aiAndMlXsWebp from './assets/AIAndML-xs.webp'
import aiAndMlXsPng2x from './assets/AIAndML-xs@2x.png'
import aiAndMlXsWebp2x from './assets/AIAndML-xs@2x.webp'
import aiAndMlSmPng from './assets/AIAndML-sm.png'
import aiAndMlSmWebp from './assets/AIAndML-sm.webp'
import aiAndMlSmPng2x from './assets/AIAndML-sm@2x.png'
import aiAndMlSmWebp2x from './assets/AIAndML-sm@2x.webp'

import personalizationXsPng from './assets/Personalization-xs.png'
import personalizationXsWebp from './assets/Personalization-xs.webp'
import personalizationXsPng2x from './assets/Personalization-xs@2x.png'
import personalizationXsWebp2x from './assets/Personalization-xs@2x.webp'
import personalizationSmPng from './assets/Personalization-sm.png'
import personalizationSmWebp from './assets/Personalization-sm.webp'
import personalizationSmPng2x from './assets/Personalization-sm@2x.png'
import personalizationSmWebp2x from './assets/Personalization-sm@2x.webp'

interface DataVisualization {
  pngSrc: string
  png2xSrc: string
  webpSrc: string
  webp2xSrc: string
}

export interface KeyFinding {
  heading: string
  description: string[]
  dataVisalization: {
    desktop: DataVisualization
    mobile: DataVisualization
    alt: string
  }
}

const keyFindings: KeyFinding[] = [
  {
    heading: `Staying ahead of the curve: Investing in personalization despite economic uncertainty`,
    description: [
      `Despite economic uncertainty, it’s encouraging to see that 69% of businesses we surveyed are increasing their investment in personalization.`,
      `This suggests that businesses recognize the value of personalization in creating engaging and loyal customer relationships, even in tough times.`,
    ],
    dataVisalization: {
      desktop: {
        pngSrc: stayingAheadOfTheCurveSmPng,
        png2xSrc: stayingAheadOfTheCurveSmPng2x,
        webpSrc: stayingAheadOfTheCurveSmWebp,
        webp2xSrc: stayingAheadOfTheCurveSmWebp2x,
      },
      mobile: {
        pngSrc: stayingAheadOfTheCurveXsPng,
        png2xSrc: stayingAheadOfTheCurveXsPng2x,
        webpSrc: stayingAheadOfTheCurveXsWebp,
        webp2xSrc: stayingAheadOfTheCurveXsWebp2x,
      },
      alt: `69% of business leaders are increasing their investment in personalization despite challenging economic headwinds.`,
    },
  },
  {
    heading: `Want to retain your customers? Keep it personal`,
    description: [
      `Looking more closely at the value of personalization, it’s clear why the majority of business leaders we surveyed are increasing their investment in this area.`,
      `Our data shows that businesses are well aware of the benefits that personalization can offer, with the majority citing the ability to help retain current customers.`,
    ],
    dataVisalization: {
      desktop: {
        pngSrc: wantToRetainCustomersSmPng,
        png2xSrc: wantToRetainCustomersSmPng2x,
        webpSrc: wantToRetainCustomersSmWebp,
        webp2xSrc: wantToRetainCustomersSmWebp2x,
      },
      mobile: {
        pngSrc: wantToRetainCustomersXsPng,
        png2xSrc: wantToRetainCustomersXsPng2x,
        webpSrc: wantToRetainCustomersXsWebp,
        webp2xSrc: wantToRetainCustomersXsWebp2x,
      },
      alt: `62% of business leaders cite improved customer retention as a benefit of personalization efforts.`,
    },
  },
  {
    heading: `The payoff: How investing in personalization delivers real returns`,
    description: [
      `Once again our data shows that consumers want to feel like VIPs when they’re interacting with businesses. Over half of consumers say they are more likely to make a repeat purchase after a personalized experience.`,
      `Personalization is the new black in the business world – it’s always in style. By tailoring experiences to their customers’ needs and preferences, businesses can create a bond that’s hard to break.`,
    ],
    dataVisalization: {
      desktop: {
        pngSrc: thePayoffSmPng,
        png2xSrc: thePayoffSmPng2x,
        webpSrc: thePayoffSmWebp,
        webp2xSrc: thePayoffSmWebp2x,
      },
      mobile: {
        pngSrc: thePayoffXsPng,
        png2xSrc: thePayoffXsPng2x,
        webpSrc: thePayoffXsWebp,
        webp2xSrc: thePayoffXsWebp2x,
      },
      alt: `Over half (56%) of consumers say they will become repeat buyers after a personalized experience, a 7% increase year-over-year.`,
    },
  },
  {
    heading: `AI is driving next-level customer experiences`,
    description: [
      `Reaching <a href="https://www.reuters.com/technology/chatgpt-sets-record-fastest-growing-user-base-analyst-note-2023-02-01/">100 million daily active users</a> just two months after launch, Chat-GPT ushered in a craze for AI and machine learning (ML) – and it seems businesses have caught on.`,
      `Our survey shows that organizations are increasingly adopting AI and machine learning to power their personalization efforts.`,
    ],
    dataVisalization: {
      desktop: {
        pngSrc: aiAndMlSmPng,
        png2xSrc: aiAndMlSmPng2x,
        webpSrc: aiAndMlSmWebp,
        webp2xSrc: aiAndMlSmWebp2x,
      },
      mobile: {
        pngSrc: aiAndMlXsPng,
        png2xSrc: aiAndMlXsPng2x,
        webpSrc: aiAndMlXsWebp,
        webp2xSrc: aiAndMlXsWebp2x,
      },
      alt: `More than 9 in 10 companies (92%) are using AI-driven personalization to drive business growth.`,
    },
  },
  {
    heading: `Personalization in the age of privacy`,
    description: [
      `It’s no surprise that trust is becoming increasingly important when it comes to personalization efforts. With data breaches and privacy scandals making headlines all too often, consumers are understandably wary of giving away their personal information.`,
      `But fear not, business leaders, there’s still hope. By being transparent and respecting data privacy, brands can earn the trust of their customers and deliver personalized experiences that delight and inspire loyalty.`,
    ],
    dataVisalization: {
      desktop: {
        pngSrc: personalizationSmPng,
        png2xSrc: personalizationSmPng2x,
        webpSrc: personalizationSmWebp,
        webp2xSrc: personalizationSmWebp2x,
      },
      mobile: {
        pngSrc: personalizationXsPng,
        png2xSrc: personalizationXsPng2x,
        webpSrc: personalizationXsWebp,
        webp2xSrc: personalizationXsWebp2x,
      },
      alt: `Just half (51%) of consumers trust brands to keep their personal data secure and use it responsibly.`,
    },
  },
]

export default keyFindings
